import { render, staticRenderFns } from "./WordFavList.vue?vue&type=template&id=6338192c&scoped=true&"
import script from "./WordFavList.vue?vue&type=script&lang=js&"
export * from "./WordFavList.vue?vue&type=script&lang=js&"
import style0 from "./WordFavList.vue?vue&type=style&index=0&id=6338192c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6338192c",
  null
  
)

export default component.exports